import React, { useState } from 'react';
import { Box } from '@mui/material';
import MyLoader from '../../Timesheets/TimingLoader/Timing_Loader';

const WorkReportLoader = () => {
    const [showError, setShowError] = useState(false);
    const [showError1, setShowError1] = useState(false);
  
    return (
        <>
            <Box>
                <MyLoader
                    showError={showError1}
                    setShowError={setShowError1}
                    style={{ width: '100%' }}
                />
            </Box>
        </>
    )
};
export default WorkReportLoader;

